import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import manifest from "../../../data/portfolioManifest.json";
import { MasonryGallery } from "./MasonryGallery";
import { LightboxModal } from "./LightboxModal";

const categories = [
  { id: "matte-painting", label: "Matte Painting" },
  { id: "concept-art", label: "Concept Art" },
];

const PortfolioGrid = ({ selectedCategory, onCategoryChange }) => {
  const [hoveredItem, setHoveredItem] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const galleryItems = useMemo(() => {
    const rawItems =
      selectedCategory === "matte-painting"
        ? manifest.mattePainting ?? []
        : manifest.conceptArt ?? [];

    return rawItems.map((it) => ({
      name: it.name,
      title: it.title,
      src: it.src,
      alt: it.alt || it.title || it.name,
    }));
  }, [selectedCategory]);

  return (
    <section id="portfolio" className="pb-20 px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">Portfolio</h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            A selection of digital matte paintings and concept art from film and television projects.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((cat) => (
            <button
              key={cat.id}
              onClick={() => onCategoryChange(cat.id)}
              className={`px-6 py-3 text-sm font-medium transition-all border border-white/15 ${
                selectedCategory === cat.id
                  ? "bg-[#ffab3e] text-black"
                  : "bg-white/5 text-gray-300 hover:bg-white/10 hover:text-white"
              }`}
            >
              {cat.label}
            </button>
          ))}

          <Link
            to="/showreel"
            className="px-6 py-3 text-sm font-medium transition-all border border-white/15 bg-white/5 text-gray-300 hover:bg-white/10 hover:text-white"
          >
            Show Reel
          </Link>
        </div>

        {/* Gallery (masonry-style like legacy site) */}
        <MasonryGallery
          items={galleryItems}
          columnsClassName="columns-1 md:columns-2"
          gapClassName="gap-6"
          onItemClick={(idx) => setLightboxIndex(idx)}
        />

        <LightboxModal
          items={galleryItems}
          index={lightboxIndex}
          arrowStyle="transparent"
          onClose={() => setLightboxIndex(null)}
          onPrev={() =>
            setLightboxIndex((prev) => {
              if (prev == null) return prev;
              return (prev - 1 + galleryItems.length) % galleryItems.length;
            })
          }
          onNext={() =>
            setLightboxIndex((prev) => {
              if (prev == null) return prev;
              return (prev + 1) % galleryItems.length;
            })
          }
        />

        {/* Note about adding images */}
        <div className="mt-12 text-center">
          <p className="text-gray-500 text-sm">
            Add your portfolio images to /public/assets/portfolio/
          </p>
        </div>
      </div>
    </section>
  );
};

export default PortfolioGrid;
